import React, { useEffect } from 'react';
import { Modal, Form, Input, message } from 'antd';
import { updateProjectDoc } from '@/pages/documentCompile/api/data-project-doc';
import { updateFolder } from '@/pages/documentCompile/api/data-project-folder';
import useStore from '@/pages/documentCompile/store/useStore';
import { useShallow } from 'zustand/react/shallow';
import { useSearchParams } from 'react-router-dom';

interface RenameModalProps {
  visible: boolean;
  onCancel: () => void;
  onSuccess: () => void;
  record: any;
  requestId?: string;
  folderId?: string | number;
}

const RenameModal: React.FC<RenameModalProps> = ({
  visible,
  onCancel,
  onSuccess,
  record,
  requestId,
  folderId
}) => {
  const [form] = Form.useForm();
  // const { projectDetail } = useStore(useShallow(s => ({
  //   projectDetail: s.projectDetail
  // })));
  // 获取地址上的 projectId
  const [searchParams] = useSearchParams();
  const projectId = searchParams.get('projectId');

  const isFolder = record?.isFolder;
  const itemType = isFolder ? '文件夹' : '文件';
  useEffect(() => {
    if (visible && record) {
      form.setFieldsValue({
        fileName: record.fileName
      });
    }
  }, [visible, record, form]);

  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      const isFolder = record.isFolder;

      if (isFolder) {
        // 重命名文件夹
        const params = {
          requestId: requestId,
          folderId: record.id,
          folderName: values.fileName,
          projectId: projectId
        };
        await updateFolder(params, requestId);
      } else {
        // 重命名文件
        const params = {
          projectId: projectId,
          docId: record.id,
          folderId: folderId,
          docName: values.fileName
        };
        await updateProjectDoc(params, requestId);
      }

      message.success('重命名成功');
      form.resetFields();
      onSuccess();
    } catch (error) {
      message.error('重命名失败');
      console.error("重命名失败", error)
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onCancel();
  };

  return (
    <Modal
      title={`重命名${itemType}`}
      open={visible}
      onOk={handleOk}
      onCancel={handleCancel}
      width={600}
      destroyOnClose
    >
      <Form form={form} layout="vertical">
        <Form.Item
          label={`新${itemType}名`}
          name="fileName"
          rules={[{ required: true, message: `请输入新${itemType}名` }]}
        >
          <Input placeholder={`请输入新${itemType}名`} onPressEnter={handleOk} />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default RenameModal;
